import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M3 18C3.55228 18 4 18.4477 4 19C4 19.5523 3.55228 20 3 20C2.44772 20 2 19.5523 2 19C2 18.4477 2.44772 18 3 18ZM21 19.75H8V18.25H21V19.75ZM3 11C3.55228 11 4 11.4477 4 12C4 12.5523 3.55228 13 3 13C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11ZM21 12.75H8V11.25H21V12.75ZM3 4C3.55228 4 4 4.44772 4 5C4 5.55228 3.55228 6 3 6C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4ZM21 5.75H8V4.25H21V5.75Z",
			fill: "currentColor"
		})
	})
});
export default SvgList;
